/**
 * Esqueleto de carga.
 *
 * Dibuja la forma de la tabla en lugar de un «Cargando…» centrado, para que
 * al llegar los datos la página no dé un salto. Es deliberadamente sobrio:
 * una animación llamativa en cada carga cansa a quien usa esto todo el día.
 */
export function DataTableSkeleton({ columns, rows = 5 }: { columns: number; rows?: number }) {
  return (
    <div className="animate-pulse" aria-hidden>
      <div className="flex gap-4 border-b border-white/10 bg-white/[0.04] px-4 py-3">
        {Array.from({ length: columns }).map((_, i) => (
          <span key={i} className="h-3 flex-1 rounded bg-white/10" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, fila) => (
        <div key={fila} className="flex gap-4 border-b border-white/5 px-4 py-3">
          {Array.from({ length: columns }).map((_, col) => (
            <span
              key={col}
              className="h-3 flex-1 rounded bg-white/[0.06]"
              // Anchos desiguales: una rejilla perfecta no parece una tabla
              // con datos, y el esqueleto está para prometer lo que viene.
              style={{ maxWidth: col === 0 ? "none" : `${60 + ((fila + col) % 3) * 15}%` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
